var APPEARANCE;
(function (APPEARANCE) {
    APPEARANCE["INLINE"] = "inline";
    APPEARANCE["OUTLINED"] = "outlined";
})(APPEARANCE || (APPEARANCE = {}));
var SIZE;
(function (SIZE) {
    SIZE["XS"] = "xs";
    SIZE["SM"] = "sm";
    SIZE["MD"] = "md";
    SIZE["LG"] = "lg";
    SIZE["XL"] = "xl";
})(SIZE || (SIZE = {}));

export { APPEARANCE, SIZE };
